// providers/AppModalProvider.tsx
import { ModalsProvider } from "@mantine/modals";
import CRUDModal from "components/ui/ConfirmModal/CRUDModal/CRUDModal";

export const AppModalProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <ModalsProvider
      modals={{
        crud: CRUDModal, // Đăng ký với key là 'crud'
        /* Bạn có thể đăng ký thêm: importModal, exportModal, v.v. */
      }}
      labels={{ confirm: "Xác nhận", cancel: "Hủy" }} // Cấu hình mặc định
      modalProps={{
        centered: true,
        padding: "md",
        // Các props chung cho toàn bộ Modal trong app
      }}
    >
      {children}
    </ModalsProvider>
  );
};
